import { User } from './models/user';

export const getFullName = ({ name, surname }: User) =>
  [name, surname].filter(Boolean).join(' ');
